import { AboutUSData } from '@/api/center/about-us/type'
import { apiGetAboutUsInfo } from '@/api/center/about-us'
import { defineStore } from 'pinia'
import { useMainStore } from '@/store/index'
import to from 'await-to-js'

export interface AbountUsState {
  aboutUsList: Array<AboutUSData>
  isFetching: boolean
}

export const useAboutUsStore = defineStore('views/center/about-us', {
  state: (): AbountUsState => ({
    aboutUsList: [],
    isFetching: false
  }),
  actions: {
    async getAboutUsInfoData() {
      this.isFetching = true
      const [err, response] = await to(
        apiGetAboutUsInfo().finally(() => {
          this.isFetching = false
        })
      )
      if (!err && response) {
        const currency = useMainStore().userInfos?.currency ?? 'CNY'
        this.aboutUsList =
          response.data.data?.filter((item) => {
            return item.currencyCodes.indexOf(currency) !== -1
          }) || []
      }
    }
  }
})
